export default __webpack_public_path__ + "static/media/connecting_web-sm@2x.7af6fa2c.jpg";